function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/outlined/application/user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "k5kujt3l6a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/user",
    style: {
      clipPath: "url(#k5kujt3l6a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/outlined/application/user (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/outlined/application/user (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.438 18.656h-1.406a.185.185 0 0 1-.188-.183 7.034 7.034 0 0 0-14.062 0 .188.188 0 0 1-.187.183H.187a.189.189 0 0 1-.073-.014.2.2 0 0 1-.061-.042.207.207 0 0 1-.041-.062.186.186 0 0 1-.012-.074 8.784 8.784 0 0 1 2.58-6.038 8.755 8.755 0 0 1 2.8-1.889h.011l.016-.007a5.814 5.814 0 1 1 6.807 0l.014.006.014.006a8.808 8.808 0 0 1 5.381 7.929.186.186 0 0 1-.013.073.177.177 0 0 1-.041.062.181.181 0 0 1-.061.042.186.186 0 0 1-.07.008zM8.813 1.781a4.035 4.035 0 1 0 2.849 1.182 4 4 0 0 0-2.849-1.182z",
    transform: "translate(3.188 2.672)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIconWhite);
export default __webpack_public_path__ + "static/media/avatarIcon_white.0d8820e198f4ad151bc6004a9d1cbcf1.svg";
export { ForwardRef as ReactComponent };